/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsSetPluginAssignments } from "../funcs/pluginsSetPluginAssignments.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SetPluginAssignmentsResponseBody } from "../models/components/setpluginassignmentsresponsebody.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  SetPluginAssignmentsRequest,
  SetPluginAssignmentsSecurity,
} from "../models/operations/setpluginassignments.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type SetPluginAssignmentsMutationVariables = {
  request: SetPluginAssignmentsRequest;
  security?: SetPluginAssignmentsSecurity | undefined;
  options?: RequestOptions;
};

export type SetPluginAssignmentsMutationData = SetPluginAssignmentsResponseBody;

export type SetPluginAssignmentsMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * setPluginAssignments plugins
 *
 * @remarks
 * Replace all assignments for a plugin with the given list of principal URNs.
 */
export function useSetPluginAssignmentsMutation(
  options?: MutationHookOptions<
    SetPluginAssignmentsMutationData,
    SetPluginAssignmentsMutationError,
    SetPluginAssignmentsMutationVariables
  >,
): UseMutationResult<
  SetPluginAssignmentsMutationData,
  SetPluginAssignmentsMutationError,
  SetPluginAssignmentsMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildSetPluginAssignmentsMutation(client, options),
    ...options,
  });
}

export function mutationKeySetPluginAssignments(): MutationKey {
  return ["@gram/client", "plugins", "setPluginAssignments"];
}

export function buildSetPluginAssignmentsMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: SetPluginAssignmentsMutationVariables,
  ) => Promise<SetPluginAssignmentsMutationData>;
} {
  return {
    mutationKey: mutationKeySetPluginAssignments(),
    mutationFn: function setPluginAssignmentsMutationFn({
      request,
      security,
      options,
    }): Promise<SetPluginAssignmentsMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(pluginsSetPluginAssignments(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
